// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36WTE","type":"styles_type__9MMIu","choices":"styles_choices__2uMia"};